import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Comensais Escola",
  path: "/merenda/merescolacardapio",
  name: "merescolacardapio",
  component: () => import("@/views/merenda/merescolacardapio/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.COMENSAISPORESCOLANOVO_MENU_1000200799],
  },
  goesToMenu: true,
 },
];
